module.exports = __webpack_public_path__ + "img/gallery.c9dc30fe.svg";